export const baseOptions: object = {
	mode: 'htmlmixed',
	tabSize: 4,
	styleActiveLine: true,
	lineNumbers: true,
	smartIndent: true,
	line: true,
	lineWrapping: true,
	foldGutter: true,
	styleSelectedText: true,
	keyMap: 'sublime',
	matchBrackets: true,
	showCursorWhenSelecting: true,
	extraKeys: { Ctrl: 'autocomplete' },
	hintOptions: {
		completeSingle: false
	}
};

export const allEvents: Array<string> = [
	'scroll',
	'changes',
	'beforeChange',
	'cursorActivity',
	'keyHandled',
	'inputRead',
	'electricInput',
	'beforeSelectionChange',
	'viewportChange',
	'swapDoc',
	'gutterClick',
	'gutterContextMenu',
	'focus',
	'blur',
	'refresh',
	'optionChange',
	'scrollCursorIntoView',
	'update'
];
